export default function usePagination({ pagination, pageSearchParams }) {
  const { page, totalPages, paginationLimit, paginationUnsupported } = pagination || {};
  const hasPaginationLimit = !!paginationLimit;
  const pageCountLimit = paginationUnsupported
    ? 1
    : hasPaginationLimit
    ? paginationLimit
    : totalPages;
  const prevPage = page > 1 ? page - 1 : null;
  const nextPage = page < pageCountLimit ? page + 1 : null;
  const prevSearchParams = { ...pageSearchParams, page: prevPage };
  const nextSearchParams = { ...pageSearchParams, page: nextPage };

  return {
    page,
    prevPage,
    nextPage,
    prevSearchParams,
    nextSearchParams,
    pageCountLimit,
  };
}
